
define('text!_lightbox.html',[],function () { return '<div class="frame">\r\n  <img>\r\n  <div class="lb-credit"></div>\r\n  <div class="lb-caption"></div>\r\n</div>';});

